export function datesFormatTime(date: Date): string {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const minString = minutes < 10 ? '0' + minutes : '' + minutes;
  return hours + ':' + minString + ' ' + ampm;
}

export function datesFromString(str: string) {
  const time = Date.parse(str);
  const date = new Date(time);
  return date;
}

export function datesFormatDate(date: Date) {
  return date.toLocaleDateString();
}

export function datesFormatTimeDate(date: Date): string {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);
  return `${hours}:${minutes} ${month}/${day}/${year}`;
}

export function datesFormatTimeDateFromString(str: string): string {
  const date = datesFromString(str);
  return datesFormatTimeDate(date);
}

export function datesLocaleFormatTimeDate(date: Date): string {
  return date.toLocaleString().replace(',', '');
}
